import { render, staticRenderFns } from "./AzAudioRecorder.vue?vue&type=template&id=3cc94ac9&"
import script from "./AzAudioRecorder.vue?vue&type=script&lang=js&"
export * from "./AzAudioRecorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports